var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6953 0.390644C15.7526 0.390644 17.5806 2.04364 17.6093 4.80897V13.1247C17.6093 15.9288 15.7765 17.6094 12.6953 17.6094H5.30561C4.91149 17.6094 4.53746 17.5818 4.18544 17.5276L3.9769 17.4923C1.70881 17.0678 0.390625 15.5044 0.390625 13.1247V4.87526C0.390625 4.58771 0.409757 4.31221 0.448021 4.04876C0.781872 1.73715 2.54679 0.390644 5.30561 0.390644H12.6953ZM12.6867 1.64503H5.30561C2.95621 1.64503 1.76525 2.73239 1.76525 4.87526V13.1247C1.76525 15.2676 2.95621 16.355 5.30561 16.355H12.6867C15.0351 16.355 16.2184 15.2676 16.2184 13.1247V4.87526C16.2184 2.73239 15.0351 1.64503 12.6867 1.64503ZM12.437 12.0219C12.8139 12.0219 13.1191 12.3008 13.1191 12.6452C13.1191 12.9896 12.8139 13.2685 12.437 13.2685H5.53902C5.16212 13.2685 4.85601 12.9896 4.85601 12.6452C4.85601 12.3008 5.16212 12.0219 5.53902 12.0219H12.437ZM12.437 8.37238C12.7001 8.34655 12.9574 8.46019 13.098 8.66423C13.2387 8.87 13.2387 9.13 13.098 9.33576C12.9574 9.53981 12.7001 9.65345 12.437 9.62762H5.53902C5.18891 9.59146 4.92393 9.32199 4.92393 9C4.92393 8.67801 5.18891 8.40768 5.53902 8.37238H12.437ZM8.17157 4.73148C8.52168 4.76678 8.78666 5.03711 8.78666 5.3591C8.78666 5.68023 8.52168 5.95057 8.17157 5.98586H5.54763C5.19656 5.95057 4.93158 5.68023 4.93158 5.3591C4.93158 5.03711 5.19656 4.76678 5.54763 4.73148H8.17157Z",
    fill: "#1890FF",
    stroke: "#1890FF",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.7324cdab2c8bfd81f0b652818d8c13ba.svg";
export { ForwardRef as ReactComponent };